import React from "react";
import { Award } from "lucide-react";
import { useExperience } from "@/hooks/use-experience";
import { useLocation, useNavigate } from "react-router-dom";

export const RankPill: React.FC = () => {
  const { experience, isLoading, error } = useExperience();
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname === "/achievements";

  const content = (() => {
    if (isLoading) return { rank: "…", level: "" };
    if (error || !experience) return { rank: "—", level: "" };
    return { rank: experience.currentRank, level: `Lv ${experience.currentLevel}` };
  })();

  const title = isLoading
    ? "Loading rank"
    : error || !experience
    ? "Open Achievements"
    : `Open Achievements — ${content.rank} • ${content.level}`;

  return (
    <button
      type="button"
      onClick={() => navigate("/achievements")}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          navigate("/achievements");
        }
      }}
      aria-label="Open Achievements"
      title={title}
      className={`win95-button select-none flex items-center gap-1 md:gap-2 h-7 md:h-8 px-2 md:px-3 text-[11px] md:text-sm border border-win95-black ${
        isActive
          ? "bg-blue-500 text-white"
          : "bg-win95-lightgray text-win95-text hover:bg-gray-200"
      }`}
    >
      <Award className="h-3.5 w-3.5 md:h-4 md:w-4 opacity-80" />
      <span className="font-medium tracking-tight">
        <span className="sm:hidden">{experience?.currentLevel ?? "—"}</span>
        <span className="hidden sm:inline">{content.rank}</span>
      </span>
      {content.level && (
        <span className="hidden sm:inline text-[10px] md:text-xs opacity-80">{content.level}</span>
      )}
    </button>
  );
};

export default RankPill;
